import React from 'react';
import { render } from 'react-dom';
import 'intersection-observer';
import App from './components/App';
import { PROD_ENV, USE_INTERCOM_CHAT } from './constants/env';
import {
  redirectToAdminWebsite,
  deviceTypeDetecting,
  enableServiceWorker,
  windowIntlPolyfill,
  initialLoader,
  loadFonts,
  loadSVG,
  addIntercomIntegration,
} from './bootstrapUtils';
import './index.styl';
import './utils/sentry';

redirectToAdminWebsite();
initialLoader();

if (PROD_ENV) {
  enableServiceWorker();
}

windowIntlPolyfill()
  .then(() => render(<App />, document.getElementById('root')))
  .catch(() => console.log('!error during polyfill loading'));

loadSVG();
loadFonts();
deviceTypeDetecting();

if (JSON.parse(USE_INTERCOM_CHAT)) {
  addIntercomIntegration();
}



// WEBPACK FOOTER //
// ./src/index.jsx